import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faCalendarAlt, faBriefcase, faUsers, faMoneyBillAlt, faChurch, faGraduationCap, faComments, faUserTie, faUser, faTachometerAlt, faBell, faSearch, faCog, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';

const HeaderAdmin = () => {
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const [showUserMenu, setShowUserMenu] = useState(false);

    const toggleMobileMenu = () => {
        setShowMobileMenu(!showMobileMenu);
    }

    const navItems = [
        { to: "/Dashboard", icon: faTachometerAlt, label: "Dashboard" },
        { to: "/Director", icon: faUser, label: "Director" },
        { to: "/Chairperson", icon: faUserTie, label: "Chairperson" },
        { to: "/Secretariat", icon: faBriefcase, label: "Secretariat" },
        { to: "/Treasury", icon: faMoneyBillAlt, label: "Treasury" },
        { to: "/Planning", icon: faCalendarAlt, label: "Planning" },
        { to: "/Parliamentarian", icon: faUsers, label: "Parliamentarian" },
        { to: "/Projects", icon: faBriefcase, label: "Projects" },
        { to: "/Education", icon: faGraduationCap, label: "Education" },
        { to: "/Communication", icon: faComments, label: "Communication" },
        { to: "/Chaplaincy", icon: faChurch, label: "Chaplaincy" },
        { to: "/Profile", icon: faUser, label: "Profile" }
    ];

    return (
        <>
            {/* Top Header */}
            <header className="fixed w-full top-0 z-50 bg-gradient-to-r from-gray-900 to-gray-800 shadow-2xl">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="flex items-center justify-between h-16">
                        {/* Left Section */}
                        <div className="flex items-center">
                            <button
                                onClick={toggleMobileMenu}
                                className="text-white p-2 mr-4 rounded-lg hover:bg-white/10 transition-colors duration-300 lg:hidden"
                            >
                                <FontAwesomeIcon icon={showMobileMenu ? faTimes : faBars} />
                            </button>
                            
                            <Link to="/Dashboard" className="flex items-center space-x-3">
                                <div className="relative">
                                    <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-xl flex items-center justify-center">
                                        <span className="text-white font-bold text-lg">AY</span>
                                    </div>
                                    <div className="absolute -top-1 -right-1 w-4 h-4 bg-emerald-400 rounded-full animate-ping"></div>
                                </div>
                                <div>
                                    <span className="text-white font-bold text-xl tracking-wider">Admin Panel</span>
                                    <div className="text-cyan-300 text-xs">Woodlands Conference</div>
                                </div>
                            </Link>
                        </div>

                        {/* Center Section - Search */}
                        <div className="hidden md:flex flex-1 max-w-xl mx-8">
                            <div className="relative w-full">
                                <input
                                    type="text"
                                    placeholder="Search admin panel..."
                                    className="w-full px-4 py-2 bg-white/10 text-white placeholder-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:bg-white/20"
                                />
                                <button className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-300 hover:text-white">
                                    <FontAwesomeIcon icon={faSearch} />
                                </button>
                            </div>
                        </div>

                        {/* Right Section */}
                        <div className="flex items-center space-x-4">
                            {/* Notifications */}
                            <button className="relative text-white p-2 rounded-lg hover:bg-white/10 transition-colors duration-300">
                                <FontAwesomeIcon icon={faBell} />
                                <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-xs rounded-full flex items-center justify-center">
                                    3
                                </span>
                            </button>

                            {/* Settings */}
                            <button className="text-white p-2 rounded-lg hover:bg-white/10 transition-colors duration-300">
                                <FontAwesomeIcon icon={faCog} />
                            </button>

                            {/* User Menu */}
                            <div className="relative">
                                <button
                                    onClick={() => setShowUserMenu(!showUserMenu)}
                                    className="flex items-center space-x-3 p-2 rounded-lg hover:bg-white/10 transition-colors duration-300"
                                >
                                    <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-full flex items-center justify-center">
                                        <span className="text-white font-semibold">A</span>
                                    </div>
                                    <div className="hidden md:block text-left">
                                        <div className="text-white font-medium">Administrator</div>
                                        <div className="text-gray-300 text-xs">Super Admin</div>
                                    </div>
                                </button>

                                {/* User Dropdown */}
                                {showUserMenu && (
                                    <div className="absolute right-0 mt-2 w-64 bg-white rounded-xl shadow-2xl overflow-hidden">
                                        <div className="p-4 bg-gradient-to-r from-blue-500 to-cyan-500 text-white">
                                            <div className="flex items-center space-x-3">
                                                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                                                    <span className="text-xl font-bold">A</span>
                                                </div>
                                                <div>
                                                    <div className="font-bold">Administrator</div>
                                                    <div className="text-sm opacity-90">admin@wcay.org</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="py-2">
                                            {[
                                                { icon: faUser, label: 'My Profile', href: '/Profile' },
                                                { icon: faCog, label: 'Settings', href: '/Settings' },
                                                { icon: faBell, label: 'Notifications', href: '/Notifications' },
                                                { icon: faBriefcase, label: 'My Projects', href: '/Projects' }
                                            ].map((item, idx) => (
                                                <Link
                                                    key={idx}
                                                    to={item.href}
                                                    className="flex items-center space-x-3 px-4 py-3 text-gray-700 hover:bg-gray-50 transition-colors duration-300"
                                                >
                                                    <FontAwesomeIcon icon={item.icon} className="text-gray-400" />
                                                    <span>{item.label}</span>
                                                </Link>
                                            ))}
                                            <div className="border-t border-gray-200 mt-2 pt-2">
                                                <button className="flex items-center space-x-3 px-4 py-3 text-red-600 hover:bg-red-50 w-full transition-colors duration-300">
                                                    <FontAwesomeIcon icon={faSignOutAlt} />
                                                    <span>Logout</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* Sidebar */}
            <aside className={`fixed left-0 top-16 h-[calc(100vh-4rem)] w-64 bg-gradient-to-b from-gray-900 to-gray-800 shadow-2xl transform transition-transform duration-300 ${
                showMobileMenu ? 'translate-x-0' : '-translate-x-full'
            } lg:translate-x-0 lg:static lg:h-auto lg:block`}>
                <div className="h-full overflow-y-auto">
                    {/* Search Mobile */}
                    <div className="p-4 lg:hidden">
                        <div className="relative">
                            <input
                                type="text"
                                placeholder="Search..."
                                className="w-full px-4 py-2 bg-white/10 text-white placeholder-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                            <button className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-300">
                                <FontAwesomeIcon icon={faSearch} />
                            </button>
                        </div>
                    </div>

                    {/* Navigation */}
                    <nav className="p-4">
                        <div className="space-y-2">
                            {navItems.map((item, idx) => (
                                <Link
                                    key={idx}
                                    to={item.to}
                                    className="flex items-center space-x-3 px-4 py-3 text-gray-300 hover:text-white hover:bg-white/10 rounded-xl transition-all duration-300 group"
                                    onClick={() => window.innerWidth < 1024 && setShowMobileMenu(false)}
                                >
                                    <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-cyan-500 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                                        <FontAwesomeIcon icon={item.icon} className="text-white text-sm" />
                                    </div>
                                    <span className="font-medium">{item.label}</span>
                                </Link>
                            ))}
                        </div>

                        {/* Quick Stats */}
                        <div className="mt-8 p-4 bg-white/5 rounded-xl">
                            <h4 className="text-gray-300 text-sm font-semibold mb-3">Quick Stats</h4>
                            <div className="space-y-2">
                                <div className="flex justify-between text-xs">
                                    <span className="text-gray-400">Users Online</span>
                                    <span className="text-green-400 font-bold">42</span>
                                </div>
                                <div className="flex justify-between text-xs">
                                    <span className="text-gray-400">Pending Tasks</span>
                                    <span className="text-amber-400 font-bold">8</span>
                                </div>
                                <div className="flex justify-between text-xs">
                                    <span className="text-gray-400">Storage</span>
                                    <span className="text-blue-400 font-bold">78%</span>
                                </div>
                            </div>
                        </div>

                        {/* Help Section */}
                        <div className="mt-4 p-4 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 rounded-xl">
                            <h4 className="text-white text-sm font-semibold mb-2">Need Help?</h4>
                            <p className="text-gray-300 text-xs mb-3">Contact support for assistance</p>
                            <button className="w-full bg-white text-blue-600 text-sm font-semibold py-2 rounded-lg hover:bg-gray-100 transition-colors duration-300">
                                Contact Support
                            </button>
                        </div>
                    </nav>
                </div>
            </aside>

            {/* Overlay for mobile */}
            {showMobileMenu && (
                <div 
                    className="fixed inset-0 bg-black/50 z-40 lg:hidden"
                    onClick={() => setShowMobileMenu(false)}
                ></div>
            )}
        </>
    );
}

export default HeaderAdmin;